import EventManager from "../../../store/sqftEventManager";
import workspace from "../../workspace";
import config from "../../../store/sqftConfig";
import ModelText from "./model/modelText";
import {getPointField} from "../../../../../helpers/sqftHelper";
import $ from "jquery";
import {setIsItextEditing} from "../../../../../../../actions/sqftMenuFunctions";
import store from "../../../../../../../store";

export default class IText {

  _modelText;
  _fontHeight = 1;
  _hMargin = 11;
  wMargin = 14;
  fillStyle = '#999999'; // fontColor
  fillStyleGray = '#999999';
  fillStyleTransparent = "rgba(255, 255, 255, 0.5)";
  lineHeight = 1.2; //1.286;
  placeholder;
  state = {
    active: false
  };

  constructor(txt, font, posX, posY, width, height, angle, parent = workspace) {
    this.placeholder = workspace.intl ? workspace.intl.formatMessage({ id: "sqft.workspace.label.addText" }) : "Add Text";
    if(txt === ''){
      txt = this.placeholder;
    }
    this.modelText = new ModelText(txt, font, posX, posY, width, height, angle, parent);
    this.initEvents();
    if(parent.children) {
      parent.children.push(this);
    }
  }

  get modelText() {
    return this._modelText;
  }

  set modelText(value) {
    this._modelText = value;
  }

  get fontHeight() {
    return this._fontHeight * config.scale / config.defaultScale + (this.getDepth() / 5); // todo wtf /5 ?
  }

  set fontHeight(value) {
    this._fontHeight = value;
  }

  get hMargin() {
    // todo perhaps make borders smaller
    // return this._hMargin * config.scale / config.defaultScale;
    return this._hMargin;
  }

  set hMargin(value) {
    this._hMargin = value;
  }

  initEvents() {
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render.bind(this),
      this,
      EventManager.priorities.BOX
    );

    EventManager.addEvent(
      EventManager.events.DBLCLICK,
      this.onDblClick.bind(this),
      this,
      EventManager.priorities.IMAGE
    );

    //todo remove deleting from menu here
    // EventManager.addEvent(
    //   EventManager.events.MOUSE_UP,
    //   this.onMouseUp.bind(this),
    //   this,
    //   EventManager.priorities.BOX
    // );
  }

  delete() {
    this.deleteEvents();
  }

  deleteEvents() {
    EventManager.removeEvent(this);
  }

  deregisterEvents = () => {
    EventManager.removeEvent(this);
    this.isHidden = true;
  }

  reInitEvents = () => {
    this.initEvents();
    this.isHidden = false;
  }

  getWidth() {
    let scale = config.scale;
    let parentWidth = this.modelText.parent.width * scale;

    return parentWidth ? parentWidth: this.modelText.width * scale ;
  }

  getDepth() {
    let scale = config.scale;
    let parentHeight = this.modelText.parent.height * scale;

    return parentHeight ? parentHeight : this.modelText.height * scale ;
  }

  getPosX() {
    return this.modelText.parent.posX ? this.modelText.parent.posX : this.modelText.posX;
  }

  getPosY() {
    return this.modelText.parent.posY ? this.modelText.parent.posY : this.modelText.posY;
  }

  onDblClick(mousePos) {
    void mousePos;
    let self = this;
    let state = this.modelText.parent
      ? this.modelText.parent.mixin.movable.state
      : this.modelText.state; //todo

    if (state.hovering && !document.querySelector(".i-text")) {
      window.lineInputFocused = true;
      EventManager.stealCursor();
      const ENTER_KEY = 13;
      const textarea = this.createTextArea();

      document.querySelector(".sqft-main-grid").appendChild(textarea);

      textarea.focus();
      textarea.onkeydown = function(e) {
        if (e.keyCode === ENTER_KEY) {
          e.target.blur();
        }
      };

      const blur = function (e) {
        if (!e.target.closest('.i-text')) {
          textarea.blur();
        }
      };

      textarea.oninput =  function() {
        this.style.height = "5px";
        this.style.height = (this.scrollHeight)+"px";
      };

      textarea.onblur = function () {
        window.lineInputFocused = false;
        self.modelText.txt = textarea.value;
        // restore placeholder
        if (textarea.value === '') {
          self.modelText.txt = self.placeholder;
        }
        self.fillStyle = self.fillStyleGray; // return color back to gray
        textarea.parentNode.removeChild(textarea);
        document.removeEventListener("click", blur);
        store.dispatch(setIsItextEditing(false));
      };

      this.fillStyle = this.fillStyleTransparent; // make color transparent

      $(textarea).on("change keyup paste", function() {
        self.modelText.txt = $(this).val();
      });
      textarea.onchange = function (event) {
        void event;
        self.modelText.txt = textarea.value;
      }.bind({ hoveredText: state.hoveredText});

      setTimeout(() => {
        document.addEventListener("click", blur);
      }, 500);
      store.dispatch(setIsItextEditing(true));
      return false;
    }
  }

  wrapText(ctx, text, x, y, maxWidth, fontSize, fontFace) {
    let firstY = y;
    let lineHeight = fontSize * this.lineHeight;

    ctx.font = fontSize + "px " + fontFace;  // Set the font for the context

    // Split the text into lines using wrapWord (handles word wrapping and ellipsis)
    let lines = this.wrapWords(ctx, text, maxWidth, 1);

    // Loop through each line and draw it on the canvas
    for (let line of lines) {
      ctx.fillText(line, x, y);
      y += lineHeight;
    }

    let scale = workspace.getScale();

    // Adjust the parent box height based on the new text block height
    this.modelText.parent.mixin.movable.height = (y - firstY) / scale + (lineHeight + this.hMargin * 2) / scale;

    // Adjust point positions based on the new height
    this.modelText.parent.points.p4.modelCorePoint.mixins.movable.posY = this.modelText.parent.mixin.movable.height / 2;
    this.modelText.parent.points.p7.modelCorePoint.mixins.movable.posY = this.modelText.parent.mixin.movable.height;
  }


  // onMouseUp = () => {
  //   if (EventManager.getCursor().indexOf("delete") >= 0 && this.modelText.parent.mixin.movable.state.hovering) {
  //     this.delete();
  //   }
  // };

  render(ctx) {
    //let angle = this.modelText.angle || 0;

    let fontHeight = this.fontHeight;
    let pointField = getPointField(this.modelText.posX, this.modelText.posY, this.modelText.parent);
    // let pointField = getPointField(this.getPosX(), this.getPosY(), this.modelText.parent);

    //let txtWidth = ctx.measureText(this.modelText.txt).width + 2 * this.hMargin;
    //let scale = config.scale;
    let width = this.getWidth();
    //let height = this.getDepth();

    ctx.save();
    ctx.font = fontHeight + 'px ' + this.modelText.font;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillStyle = this.fillStyle;

    //TODO remove
    //ctx.translate(pointField.x, pointField.y);
    //ctx.translate(pointField.x + width / 2, pointField.y); //centering for scale
    //ctx.rotate(angle); // text rotation
    //ctx.lineWidth = 1;
    //ctx.strokeRect(-width / 2, 0, width, height); //rect around text
    //ctx.scale(width / txtWidth, height / fontHeight); // text scale
    //ctx.translate(this.hMargin, 0);
    //ctx.fillText(this.modelText.txt, -txtWidth/2, 0, width / 2);
    // this.wrapText(ctx, this.modelText.txt, -txtWidth/2, 0, width, this.fontHeight, this.modelText.font);
    //ctx.fillText(this.modelText.txt, pointField.x, pointField.y);
    this.wrapText(
      ctx,
      this.modelText.txt,
      pointField.x + this.wMargin,
      pointField.y + this.hMargin,
      width - this.wMargin,
      this.fontHeight,
      this.modelText.font
    );

    ctx.restore();
  }

  createTextArea() {
    let textarea = document.createElement("textarea");
    let pointField = getPointField(this.modelText.posX, this.modelText.posY, this.modelText.parent);
    let scale = workspace.getScale();

    textarea.className = "i-text";
    textarea.style.left = pointField.x + this.wMargin + "px";
    textarea.style.top = pointField.y + this.hMargin + "px"; // todo  -2 hook for first line
    textarea.style.width = this.getWidth() - this.wMargin + "px";
    // textarea.style.height = this.getDepth() + "px";
    textarea.style.height = this.modelText.parent.mixin.movable.height * scale + "px";
    textarea.style.fontSize = this.fontHeight + "px";
    textarea.style.lineHeight = this.fontHeight * this.lineHeight + 0.8 + "px"; // 2 hook for first line
    textarea.style.fontFamily = this.modelText.font;
    textarea.style.color = this.fillStyle;
    if (this.modelText.txt === this.placeholder) {
      textarea.value = '';
    } else {
      textarea.value = this.modelText.txt;
    }
    return textarea
  }

  /**
   * Split the text into lines using wrapWord (handles word wrapping and ellipsis)
   * @param ctx
   * @param testLine
   * @param maxWidth
   * @param spaces
   * @return {[]}
   */
  wrapWords(ctx, testLine, maxWidth, spaces) {
    let i = 0;
    let lines = [];
    let currentLine = '';
    const ellipsis = '...';

    // Split the text into individual words
    const words = testLine.split(' ');

    // Iterate through the words and add them to lines while checking for width
    for (let word of words) {
      let testLine = currentLine + word + ' ';
      let testWidth = ctx.measureText(testLine).width;

      // If adding the word exceeds maxWidth, move it to the next line
      if (testWidth > maxWidth) {
        // If the word itself is too long, truncate it and add ellipsis
        if (ctx.measureText(word).width > maxWidth) {
          while (ctx.measureText(word).width > maxWidth && i < word.length) {
            if (ctx.measureText(word.slice(0, i + spaces) + ellipsis).width >= maxWidth) {
              lines.push(word.slice(0, i) + ellipsis);
              return lines;
            }
            i++;
          }
        }
        // Push the current line and start a new line with the current word
        lines.push(currentLine.trim());
        currentLine = word + ' ';
      } else {
        currentLine = testLine;  // Add the word to the current line
      }
    }

    // Add the last line to the lines array
    if (currentLine.length > 0) {
      lines.push(currentLine.trim());
    }

    return lines;
  }
}
